import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import './index.css';
import {BrowserRouter, Routes, Route, useLocation} from "react-router";
import HomePage from "./screens/home-page/home.page";
import Navigation from "./screens/navigation/navigation";
import {Provider} from "./components/ui/provider";
import {Toaster} from "./components/ui/toaster";
import {AuthProvider} from "./contexts/auth-context";
import PaymentSuccess from "./screens/payment-success/payment-success";
import Footer from "./screens/footer/footer";
import Prices from "./screens/prices/prices";
import PrivacyPolicy from "./screens/privacy-policy/privacy-policy";
import Regulations from "./screens/regulations/regulations";
import Contact from "./screens/contact/contact";
import PageTracker from "./hooks/usePageTracking";
import NotFound from "./screens/not-found/not-found";
import styled from "styled-components";
import {Spinner} from "@chakra-ui/react";
import KnowledgeBase from "./screens/knowledge-base/knowledge-base";
import {articles} from './knowledge-base-articles';

// Opcjonalnie, dynamiczny import dla ścieżki /szukaj:
const SearchPage = React.lazy(() => import("./screens/home-page/home.page"));
const OrderSummary = React.lazy(() => import("./screens/order-summary/order-summary"));
const UserPanel = React.lazy(() => import("./screens/user-panel/user-panel"));

ReactGA.initialize('G-8ZYM9ZB4XX');

const LoaderContainer = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
`;
const Loader = () => {

    return <LoaderContainer>
        <Spinner color="primary" size="lg"/>
    </LoaderContainer>
}
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <Provider>
                <Toaster/>
                <BrowserRouter>
                    <PageTracker/>
                    <Navigation/>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<HomePage/>}/>
                        <Route
                            path="/szukaj"
                            element={
                                <div data-snap-ignore="true">
                                    <React.Suspense fallback={<Loader/>}>
                                        <SearchPage/>
                                    </React.Suspense>
                                </div>
                            }
                        />
                        <Route
                            path="/zamowienie"
                            element={
                                <div data-snap-ignore="true">
                                    <React.Suspense fallback={<Loader/>}>
                                        <OrderSummary/>
                                    </React.Suspense>
                                </div>
                            }
                        />
                        <Route path="/potwierdzenie-platnosci" element={<PaymentSuccess/>}/>
                        <Route
                            path="/panel-uzytkownika"
                            element={
                                <div data-snap-ignore="true">
                                    <React.Suspense fallback={<Loader/>}>
                                        <UserPanel/>
                                    </React.Suspense>
                                </div>
                            }
                        />
                        <Route path="/cennik" element={<Prices/>}/>
                        <Route path="/polityka-prywatnosci" element={<PrivacyPolicy/>}/>
                        <Route path="/regulamin" element={<Regulations/>}/>
                        <Route path="/kontakt" element={<Contact/>}/>
                        <Route path="/baza-wiedzy" element={<KnowledgeBase/>}/>
                        <Route path="*" element={<NotFound/>}/>
                        {articles.map(({url, component: Component, ...rest}) =>
                            <Route
                                path={url}
                                element={<Component  {...rest} />}
                            />
                        )}
                    </Routes>
                    <Footer/>
                </BrowserRouter>
            </Provider>
        </AuthProvider>
    </React.StrictMode>
);
